import CalendarToday from '@material-symbols/svg-300/rounded/calendar_today.svg'
import classnames from 'classnames'
import { differenceInHours } from 'date-fns'
import React from 'react'
import { useTranslation } from 'react-i18next'
import dueDateTimestamp from '../../state/calculations/dueDateTimestamp'

import styles from './DueIn.module.scss'

export default React.memo(function DueIn({
  when,
  className,
  ...htmlProps
}: { when: Date | null | undefined } & React.HTMLProps<HTMLSpanElement>) {
  const { t } = useTranslation()

  if (!when) {
    return null
  }

  const diff = differenceInHours(dueDateTimestamp(when), new Date())
  const urgency = diff < 24 * 3 ? 'veryUrgent' : 'notUrgent'

  return (
    <span className={classnames(styles.DueIn, className, styles[urgency])} {...htmlProps}>
      <CalendarToday />
      {t('learning item.due in {date}', { date: dueDateTimestamp(when) })}
    </span>
  )
})
